(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flip-cards-breathe"] && !Shopify.designMode) return;
  try {
    
  class FlipCards extends HTMLElement {
    connectedCallback() {
      this._cards = Array.from(this.querySelectorAll('[data-flip-card]'));
      if (this._cards.length === 0) return;

      this._reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
      this._touchMode = this.dataset.flipOnTouch === 'true';
      this._isTouchDevice = window.matchMedia?.('(hover: none), (pointer: coarse)')?.matches ?? false;
      this._enableToggle = this._touchMode || this._isTouchDevice;

      this.addEventListener('click', (event) => {
        if (!this._enableToggle) return;
        const card = event.target.closest?.('[data-flip-card]');
        if (!card) return;
        this._toggle(card);
      });

      this.addEventListener('keydown', (event) => {
        const card = event.target.closest?.('[data-flip-card]');
        if (!card) return;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this._toggle(card);
        }

        if (event.key === 'Escape') {
          this._setFlipped(card, false);
        }
      });
    }

    _setFlipped(card, flipped) {
      card.classList.toggle('is-flipped', flipped);
      card.setAttribute('aria-pressed', flipped ? 'true' : 'false');
    }

    _toggle(card) {
      const next = !card.classList.contains('is-flipped');
      if (this._reducedMotion) {
        this._setFlipped(card, next);
        return;
      }

      // Single-open behavior: close others when opening one.
      if (next) {
        this._cards.forEach((other) => {
          if (other !== card) this._setFlipped(other, false);
        });
      }

      this._setFlipped(card, next);
    }
  }

  if (!customElements.get('flip-cards')) {
    customElements.define('flip-cards', FlipCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-slides"] && !Shopify.designMode) return;
  try {
    
  class ScrollSlides extends HTMLElement {
    connectedCallback() {
      this._slides = Array.from(this.querySelectorAll('[data-slide]'));
      this._dots   = Array.from(this.querySelectorAll('[data-ss-dot]'));
      this._count  = this._slides.length;
      if (this._count < 1) return;

      this._activeIndex = 0;
      this._raf = null;

      // Dot click → jump to slide scroll position
      this._dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = Number(dot.dataset.ssDot);
          this._jumpTo(idx);
        });
      });

      this._onScroll = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._update();
          this._raf = null;
        });
      };

      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    _update() {
      const rect    = this.getBoundingClientRect();
      const vh      = window.innerHeight;
      const scrolled = Math.max(0, -rect.top);
      // Each slide occupies one vh worth of scroll
      const newIndex = Math.min(Math.floor(scrolled / vh), this._count - 1);

      if (newIndex === this._activeIndex) return;

      this._slides[this._activeIndex].classList.remove('is-active');
      this._dots[this._activeIndex]?.classList.remove('is-active');

      this._activeIndex = newIndex;

      this._slides[this._activeIndex].classList.add('is-active');
      this._dots[this._activeIndex]?.classList.add('is-active');
    }

    _jumpTo(index) {
      const rect    = this.getBoundingClientRect();
      const vh      = window.innerHeight;
      const top     = window.scrollY + rect.top + index * vh;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  if (!customElements.get('scroll-slides')) {
    customElements.define('scroll-slides', ScrollSlides);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-reel"] && !Shopify.designMode) return;
  try {
    
  class SocialReel extends HTMLElement {
    connectedCallback() {
      this._cards = Array.from(this.querySelectorAll('.social-reel__card'));
      this._modal = this.querySelector('[data-reel-modal]');
      this._screen = this.querySelector('[data-reel-screen]');
      this._currentIndex = -1;

      this._bindHoverPreview();
      this._bindEvents();
    }

    disconnectedCallback() {
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
    }

    // ── Hover: muted video preview ───────────────────────────────────────────

    _bindHoverPreview() {
      this._cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;
        card.addEventListener('mouseenter', () => {
          video.currentTime = 0;
          video.play().catch(() => {});
        });
        card.addEventListener('mouseleave', () => {
          video.pause();
          video.currentTime = 0;
        });
      });
    }

    // ── Event delegation ─────────────────────────────────────────────────────

    _bindEvents() {
      this.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-reel-open]');
        if (openBtn) { this._open(Number(openBtn.dataset.reelOpen)); return; }

        const card = e.target.closest('.social-reel__card');
        if (card && !e.target.closest('a, button')) {
          this._open(Number(card.dataset.cardIndex));
          return;
        }

        if (e.target.closest('[data-reel-close]')) { this._close(); return; }
        if (e.target.closest('[data-reel-prev]'))  { this._navigate(-1); return; }
        if (e.target.closest('[data-reel-next]'))  { this._navigate(1);  return; }
      });

      this._onKey = (e) => {
        if (!this._modal || this._modal.getAttribute('aria-hidden') === 'true') return;
        if (e.key === 'Escape')                            this._close();
        if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   this._navigate(-1);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown')  this._navigate(1);
      };
      document.addEventListener('keydown', this._onKey);
    }

    // ── Modal open / close ───────────────────────────────────────────────────

    _open(index) {
      this._currentIndex = index;
      this._renderScreen();
      this._modal.setAttribute('aria-hidden', 'false');
      // Shared overlay helper: focus moves to the close button, Tab stays in
      // the player, and closing restores the previous scroll lock and focus.
      window.EkatoOverlay?.open(this._modal, { initialFocus: this._modal.querySelector('.reel-modal__close') });
      this._playModalVideo();
    }

    _close() {
      if (this._modal.getAttribute('aria-hidden') === 'true') return;
      this._disposeScreenMedia();
      this._modal.setAttribute('aria-hidden', 'true');
      window.EkatoOverlay?.close(this._modal);
      this._currentIndex = -1;
    }

    _navigate(dir) {
      if (this._currentIndex < 0 || this._cards.length < 2) return;
      this._disposeScreenMedia();
      this._currentIndex = ((this._currentIndex + dir) + this._cards.length) % this._cards.length;
      this._renderScreen();
      this._playModalVideo();
    }

    _disposeScreenMedia() {
      const video = this._screen.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      const iframe = this._screen.querySelector('iframe');
      if (iframe) {
        iframe.src = 'about:blank';
      }

      this._screen.replaceChildren();
    }

    _playModalVideo() {
      const video = this._screen.querySelector('video');
      if (!video) return;
      video.muted = false;
      video.play().catch(() => { video.muted = true; video.play().catch(() => {}); });
    }

    // ── Render modal screen ──────────────────────────────────────────────────

    _renderScreen() {
      const card = this._cards[this._currentIndex];
      if (!card) return;

      const platform = card.dataset.platform || '';
      const handle   = card.dataset.handle   || '';
      const caption  = card.dataset.caption  || '';
      const externalUrl = card.dataset.externalUrl || '';
      const instagramEmbedUrl = this._instagramEmbedUrl(externalUrl);

      let mediaClone;

      if (instagramEmbedUrl) {
        mediaClone = document.createElement('iframe');
        mediaClone.src = instagramEmbedUrl;
        mediaClone.title = handle ? `Instagram de @${handle}` : 'Instagram reel';
        mediaClone.loading = 'lazy';
        mediaClone.allowFullscreen = true;
        mediaClone.referrerPolicy = 'strict-origin-when-cross-origin';
        mediaClone.setAttribute('allow', 'autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share');
      } else {
        const mediaWrap = card.querySelector('.social-reel__card-media');
        mediaClone = mediaWrap ? mediaWrap.cloneNode(true) : document.createDocumentFragment();
      }

      // Configure cloned video for modal playback
      const cloneVideo = mediaClone.querySelector && mediaClone.querySelector('video');
      if (cloneVideo) {
        cloneVideo.removeAttribute('autoplay');
        cloneVideo.loop  = true;
        cloneVideo.muted = false;
        cloneVideo.controls = false;
        cloneVideo.style.cssText = '';
      }

      // Build meta overlay
      const metaEl = document.createElement('div');
      metaEl.className = 'reel-modal__meta';

      if (platform && platform !== 'none') {
        const badge = document.createElement('div');
        badge.className = `reel-modal__platform-badge reel-modal__platform-badge--${platform}`;
        badge.insertAdjacentHTML('afterbegin', this._platformIcon(platform));
        if (handle) {
          const handleEl = document.createElement('span');
          handleEl.textContent = `@${handle}`;
          badge.appendChild(handleEl);
        }
        metaEl.appendChild(badge);
      }

      if (caption) {
        const cap = document.createElement('p');
        cap.className = 'reel-modal__caption';
        cap.textContent = caption;
        metaEl.appendChild(cap);
      }

      if (instagramEmbedUrl) {
        this._screen.replaceChildren(mediaClone);
      } else {
        const dotsEl = document.createElement('div');
        dotsEl.className = 'reel-modal__dots';
        this._cards.forEach((_, i) => {
          const dot = document.createElement('span');
          dot.className = 'reel-modal__dot' + (i === this._currentIndex ? ' is-active' : '');
          dotsEl.appendChild(dot);
        });

        this._screen.replaceChildren(mediaClone, metaEl, dotsEl);
      }

      // Show/hide nav arrows based on count
      this.querySelector('[data-reel-prev]').hidden = this._cards.length < 2;
      this.querySelector('[data-reel-next]').hidden = this._cards.length < 2;
    }

    _instagramEmbedUrl(url) {
      if (!url) return '';

      try {
        const parsedUrl = new URL(url, window.location.origin);
        const hostname = parsedUrl.hostname.replace(/^www\./, '');

        if (!['instagram.com', 'm.instagram.com'].includes(hostname)) return '';

        let pathname = parsedUrl.pathname.replace(/\/+$/, '');
        if (!pathname) return '';

        if (pathname.endsWith('/embed/captioned')) {
          return `https://www.instagram.com${pathname}/`;
        }

        if (pathname.endsWith('/embed')) {
          return `https://www.instagram.com${pathname}/captioned/`;
        }

        return `https://www.instagram.com${pathname}/embed/captioned/`;
      } catch (_) {
        return '';
      }
    }

    // ── Platform icons ───────────────────────────────────────────────────────

    _platformIcon(platform) {
      const icons = {
        instagram: '<svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>',
        tiktok:    '<svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.77 1.52V6.76a4.85 4.85 0 01-1-.07z"/></svg>',
        youtube:   '<svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15"><path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/></svg>',
        x:         '<svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>'
      };
      return icons[platform] || '';
    }
  }

  if (!customElements.get('social-reel-component')) {
    customElements.define('social-reel-component', SocialReel);
  }

  } catch(e) { console.error(e); }
})();
})();
